import React from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import classnames from "classnames";

interface StylesProps {
  disablePadding?: boolean;
  smallPadding?: boolean;
  smallBorderRadius?: boolean;
  addBorder?: boolean;
}
interface FunnelCardContainerProps extends StylesProps {
  className?: string;
}

export const FunnelCardContainer: React.FunctionComponent<FunnelCardContainerProps> = ({
  children,
  disablePadding,
  smallPadding,
  className,
  smallBorderRadius,
  addBorder,
}) => {
  const classes = useStyle({ disablePadding, smallPadding, smallBorderRadius, addBorder });
  return <div className={classnames(className, classes.container)}>{children}</div>;
};

const useStyle = makeStyles<any, StylesProps>((theme) =>
  createStyles({
    container: {
      borderRadius: (props) => (props.smallBorderRadius ? 8 : 24),
      backgroundColor: theme.palette.grey200.main,
      border: (props) => (props.addBorder ? "1px solid rgba(215, 215, 215, 0.7)" : ""),
      padding: (props) => (props.disablePadding ? null : props.smallPadding ? theme.spacing(2) : theme.spacing(4)),
      paddingBottom: theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        paddingLeft: (props) => (props.disablePadding ? null : theme.spacing(2)),
        paddingRight: (props) => (props.disablePadding ? null : theme.spacing(2)),
        paddingTop: (props) => (props.disablePadding ? null : theme.spacing(3)),
        paddingBottom: (props) => (props.disablePadding ? null : theme.spacing(3)),
      },
    },
  })
);
